import React from 'react';

const LocationAdvantageModal = ({
  isOpen,
  setIsOpen,
  inputValue,
  handleInputChange,
  handleAddAmenities,
}) => {
  if (!isOpen) return null;

  return (
    <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
      <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
        <h2 className="oms-modal-title">Add Location Advantage</h2>
        <form
          className="oms-modal-form"
          onSubmit={(e) => {
            e.preventDefault();
            handleAddAmenities();
          }}
        >
          <div className="oms-form-group">
            <label htmlFor="locationadvantage" className="oms-form-label">Location Advantage</label>
            <input
              type="text"
              id="Location Advantage"
              name="locationadvantage"
              value={inputValue}
              onChange={handleInputChange}
              placeholder="Enter Location Advantage"
              required
            />
          </div>

          <div className="oms-form-actions">
            <button type="button" onClick={() => setIsOpen(false)}>Cancel</button>
            <button type="submit">Add</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LocationAdvantageModal;
